import { EJRequestSpinState } from "states/ej-request-spin-state";
import { BlastworksClientEvent } from "../ClientController";

export class SocialRequestSpinState extends EJRequestSpinState {
    public complete(): void {
        this.stateMachine.dispatchClientEvent(BlastworksClientEvent.SPIN_RESULT);
        super.complete();
    }
}